import GraphRanges from "@/mixins/GraphRanges";
import { patientNamespace } from "@/store/modules/patient";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";

@Component({})
export default class PainScore extends mixins(GraphRanges) {
  @Getter("config", patientNamespace)
  config!: any;

  @Getter("segmentRisk", patientNamespace)
  segmentRisk!: any;

  @Getter("graph", patientNamespace)
  graph!: any;

  get charts(): MultiChartConfig[] {
    const painScoreData = this.graph(["PainScore"], true);
    if (painScoreData.length === 0) {
      return [];
    } else {
      return [
        {
          title: "Pain Score",
          data: painScoreData,
          suggestedMax: 10
        }
      ];
    }
  }
}
